import { useEffect, useMemo, useState, useRef, useContext } from "react";
import useCForm from "./hooks/useCForm";
import Img from "./Img";
import Form, { FormContext } from "app/fragments/Forms/Form";
import Button from "./Button";
import route from "ziggy-js";
import { post } from "jquery";
import Submit from "./Forms/Submit";
import isEqual from "lodash/isEqual";
import { _ } from "./Translator";
import CTextField from "app/fragments/CTextField";
import CForm from "app/fragments/Forms/CForm";


const cateringDiscountThreshold = 23100;

/* import { TextField } from "@material-ui/core"; */



type MenuItem = {
    name: string;
    detail?: string;
    price?: number;
    defaultCount?: number;
    count?: number;
};

type MenuSection = {
    title: string;
    description?: string;
    items: MenuItem[];
};

type PackageType = {
    name: string;
    sections: MenuSection[];
    pricePerPerson: number;
    minPersons: number;
    note?: string;
};

type CustomMenuType = {
    sections: MenuSection[];
    pricePerPerson: number;
    minPersons: number;
    note?: string;
    totalPrice?: number;
};

// Define the FormData interface
interface FormData {
    street: string;
    person_count: number;
    city: string;
    zip: string;
    company: string;
    name: string;
    surname: string;
    phone: string;
    event_type: string;
    package_type: string;
    email: string;
    request: string;
    agree: boolean;
    rental_packages: string;
    package_index: number | null;
    menu_custom: CustomMenuType | null;
    /* menu_custom_total_price: number; */
    menu_total_price: number;
    layout: string;
}
interface CustomMenuSectionProps {
    menu: CustomMenuType | null;
    setMenu: (menu: CustomMenuType | null) => void;
    /*     menu_custom_total_price: number; */
    menu_total_price: number;
    person_count: number;
    onSelectCustomMenu: () => void;
    form: any;
}

interface RentalPackage {
    key: string;
    title: string;
    desc: string;
    price?: string;
}

const rentalPackages: RentalPackage[] = [
    {
        key: "zakladni",
        title: "Základní pronájem",
        desc: "Stolové uspořádání, běžný úklid, personál, zázemí, inventář a mobiliář",
        price: "od 15 000 Kč"
    },
    {
        key: "rozsireny",
        title: "Rozšířený pronájem",
        desc: "Výzdoba, ozvučení, projektor, promítací plátno, inventář a mobiliář, personál, běžný úklid",
        price: "od 20 000 Kč"
    },
    {
        key: "klic",
        title: "Pronájem na klíč",
        desc: "Kompletní servis – výzdoba, koordinátor, barman, barista, hostesky, audiovizuální technika, dle přání klienta",
        price: "od 30 000 Kč"
    },
    {
        key: "full",
        title: "Poptat pronájem celého Café New One",
        desc: "Můžete pro vás uzavřít veškeré prostory, celková cena pronájmu od 50 000 Kč, více probereme individuálně",
        price: ""
    }
];


const eventImages = {
    "wedding": "/assets/img/catering/Svatba.svg",
    "congres": "/assets/img/catering/Kongres.svg",
    "event1": "/assets/img/catering/Event1.svg",
    "event2": "/assets/img/catering/Event2.svg",
    "show": "/assets/img/catering/modni_prehlidka.svg",
};
/* const mobEventImages = {
    "mobwedding": "/assets/img/catering/Svatba.svg",
    "mobcongres": "/assets/img/catering/Kongres.svg",
    "mobevent1": "/assets/img/catering/event1.svg",
    "mobevent2": "/assets/img/catering/event2.svg",
    "mobshow1": "/assets/img/catering/modni_prehlidka.svg",
};
 */
const eventLayouts = [
    { key: "wedding", label: "Svatba" },
    { key: "congres", label: "Kongres" },
    { key: "event1", label: "Večířek 50-100 osob" },
    { key: "event2", label: "Večířek 100-150 osob" },
    { key: "show", label: "Módní přehlídka" },
];

interface EventsProps {
    /* form: any; */
    onSelectCustomMenu: () => void;
    children?: React.ReactNode;
}

export function Events({ onSelectCustomMenu, children }: EventsProps) {
    const [eventType, setEventType] = useState<"cafe" | "custom">("cafe");
    const form = useContext(FormContext);
    console.log("Form data:", form.data);

    // Layout: flex row, left = content, right = sticky image
    return (
        <div className="w-full mob:px-[16px]">

            <div className="text-16 w-full text-brown-text mob:pt-16px pt-[24px]  leading-[24px]">
                <_>Nápoje nejsou zahrnuty v ceně balíčku a budou účtovány zvlášť dle skutečné spotřeby. Uvedené ceny zahrnují DPH. <br /> Nevybrali jste si?</_>
                <span
                    className="underline cursor-pointer"
                    onClick={onSelectCustomMenu}
                >
                    <_> Sestavte si menu na míru.</_>
                </span>
            </div>

            <div className="flex flex-row relative">
                {/* Left column: all event content and forms */}
                <div className="w-[85%] mob:w-full flex-col flex mx-start text-brown-text" >
                    <div className="text-24 leading-[40px] text-black font-bold pt-16px pb-8px"><_>Více o eventu</_></div>
                    <div className="text-14 leading-[24px] text-brown-text font-normal  pb-8px"><_>Místo konání</_></div>
                    {/* Přepínač Café New One / Jiná adresa */}
                    <div className="w-full mb-[64px]">
                        <div className="flex w-full relative">
                            <button
                                type="button"
                                className={`flex-1 text-[16px] font-normal text-left transition-all ${eventType === "cafe" ? "text-black" : "text-brown-text"}`}

                                onClick={() => {
                                    setEventType("cafe");
                                    form.setData("event_type", "cafe");
                                }}
                            >
                                Café New One
                            </button>
                            <button
                                type="button"
                                className={`flex-1 text-[16px] font-normal text-left transition-all ${eventType === "custom" ? "text-black" : "text-brown-text"}`}
                                onClick={() => {
                                    setEventType("custom");
                                    form.setData("event_type", "custom");
                                }}
                            >
                                Jiná adresa
                            </button>
                            {/* Border přesně pod textem, bez mezer */}
                            <span className="absolute left-0 w-full h-[2px] bottom-[-6px]">
                                <span
                                    className={`block absolute left-0 top-0 h-full w-1/2 ${eventType === "cafe" ? "bg-[#897A69]" : "bg-[#E5E5E5]"}`}
                                ></span>
                                <span
                                    className={`block absolute left-1/2 top-0 h-full w-1/2 ${eventType === "custom" ? "bg-[#897A69]" : "bg-[#E5E5E5]"}`}
                                ></span>
                            </span>
                        </div>
                    </div>





                    {/* Adresy (jen když jiná adresa) */}
                    {eventType === "custom" && (
                        <div className=" w-full border-b ">
                            <div className="mb-[8px]  text-brown-text text-[15px]"><_>Ulice a č.p.</_></div>
                            <CTextField noCheck placeholder="Ulice a č.p." name="street" className="w-full border b   py-[8px] mb-[16px] bg-white text-[15px]" />
                            <div className="flex gap-[16px]">
                                <div className="flex-1">
                                    <div className="mb-[6px]  text-brown-text text-[14px]"><_>PSČ</_></div>
                                    <CTextField placeholder="000 01" noCheck name="zip" className="w-full border   py-[8px] mb-[16px] bg-white text-[15px]" />
                                </div>
                                <div className="flex-1">
                                    <div className="mb-[6px] text-brown-text text-[14px]"><_>Město</_></div>
                                    <CTextField placeholder="Město" noCheck name="city" className="w-full border  py-[8px] mb-[16px] bg-white text-[15px]" />
                                </div>
                            </div>
                            <div className="text-[14px] text-[#666666] py-[8px] mb-[8px] flex items-center">
                                <span className="inline-block align-top mr-[8px]">ⓘ</span>
                                <_>Dopravné mimo Olomouc 20 Kč / km v obou směrech, bude vypočteno individuálně.</_>
                            </div>
                        </div>
                    )}

                    {eventType === "cafe" && (
                        <div className=" w-full mob:hidden  pb-[20px]">
                            <div className="mb-[24px] font-bold text-black text-[16px]"><_>Vyberte si rozvržení</_></div>
                            <div className="flex flex-col gap-[10px]">
                                {eventLayouts.map((opt) => (
                                    <label
                                        key={opt.key}
                                        className={`flex items-center border px-[16px] py-[12px] cursor-pointer transition-all ${form.data.layout === opt.key
                                            ? " border-black "
                                            : "border-gray bg-white "
                                            }`}
                                    >
                                        <input
                                            type="radio"
                                            required
                                            className="accent-[#666666] mr-[16px] w-[18px] h-[18px]"
                                            name="layout"
                                            value={opt.key}
                                            checked={form.data.layout === opt.key}
                                            onChange={() => form.setData("layout", opt.key)}

                                        />
                                        <span className="text-[16px] font-normal text-brown-text"><_>{opt.label}</_></span>
                                    </label>
                                ))}
                            </div>




                            <div className="mb-[14px] mt-[40px] w-full flex flex-row pb-[20px]">
                                <div className="w-full">
                                    <div className="mb-[12px] font-bold text-black text-[16px]"><_>Vyberte si balíček</_></div>
                                    <div className="flex flex-col w-full font-bold gap-[10px]">
                                        {rentalPackages.map((opt) => (
                                            <label
                                                key={opt.key}

                                                className={`flex font-normal items-start border px-[16px] py-[16px] cursor-pointer transition-all
                                                ${form.data.rental_packages === opt.key
                                                        ? " bg-white"
                                                        : "border-[#ddd] bg-white"}`}

                                                style={{ minHeight: 56 }}>

                                                <div className="flex items-center justify-center w-[24px] h-[24px]  bg-white rounded-full">
                                                    <input
                                                        required
                                                        type="radio"
                                                        className="accent-[#897A69] w-[12px] h-[12px]"
                                                        name="rental_packages"
                                                        value={opt.key}
                                                        checked={form.data.rental_packages === opt.key}
                                                        onChange={() => form.setData("rental_packages", opt.key)}
                                                        style={{ background: "white" }}
                                                    />
                                                </div>

                                                <div className="flex-1 flex flex-col min-w-0">
                                                    <div className="flex items-center justify-between w-full">
                                                        <div className="font-bold text-[16px] leading-[24px] text-brown-text"><_>{opt.title}</_></div>
                                                        {opt.price && (() => {
                                                            const match = opt.price.match(/(\d[\d\s]*)/);
                                                            const rentalCost = match ? parseInt(match[1].replace(/\s/g, ''), 10) : 0;
                                                            const cateringCost =
                                                                form.data.package_type === "custom"
                                                                    ? (form.data.menu_total_price || 0)
                                                                    : (packages[form.data.package_index]?.pricePerPerson ?? 0) * form.data.person_count;
                                                            const remaining = Math.max(cateringDiscountThreshold - cateringCost, 0);
                                                            const isDiscounted = remaining <= 0;
                                                            if (isDiscounted) {
                                                                // Zobraz přeškrtnutou i zvýrazněnou cenu
                                                                return (
                                                                    <span className="ml-auto whitespace-nowrap font-normal text-[14px] flex items-center">
                                                                        <span className="text-brown-text font-normal line-through leading-[24px] mr-12px">
                                                                            od {rentalCost.toLocaleString("cs-CZ")} Kč
                                                                        </span>
                                                                        <span className="text-brown-text font-normal leading-[24px] text-[14px]">
                                                                            od {(rentalCost / 2).toLocaleString("cs-CZ")} Kč
                                                                        </span>
                                                                    </span>
                                                                );
                                                            } else {
                                                                // Zobraz pouze plnou cenu (bez přeškrtnutí)
                                                                return (
                                                                    <span className="ml-auto whitespace-nowrap font-normal text-[16px] text-brown-text">
                                                                        od {rentalCost.toLocaleString("cs-CZ")} Kč
                                                                    </span>
                                                                );
                                                            }
                                                        })()}
                                                    </div>
                                                    {form.data.rental_packages === opt.key && (() => {
                                                        const match = opt.price?.match(/(\d[\d\s]*)/);
                                                        const rentalCost = match ? parseInt(match[1].replace(/\s/g, ''), 10) : 0;
                                                        // Use custom menu price for cateringCost if custom, otherwise package price
                                                        const cateringCost =
                                                            form.data.package_type === "custom"
                                                                ? (form.data.menu_total_price || 0)
                                                                : (packages[form.data.package_index]?.pricePerPerson ?? 0) * form.data.person_count;
                                                        const remaining = Math.max(cateringDiscountThreshold - cateringCost, 0);
                                                        const isDiscounted = remaining <= 0;
                                                        return (
                                                            <>
                                                                {/*   {isDiscounted && (
                                                                    <p className="text-[14px] mt-[8px] text-center">
                                                                        <span className="text-white  font-normal">
                                                                            <_>Gratulujeme! Dosáhli jste 50% slevy na pronájem prostor v Café New One.</_>
                                                                        </span>
                                                                    </p>
                                                                )} */}
                                                                {/*    {!isDiscounted && (
                                                                    <p className="text-[14px] mt-[8px] text-center">
                                                                        <span className="font-bold text-brown-text">{remaining.toLocaleString("cs-CZ")} Kč</span>{' '}
                                                                        <span className="text-brown-text"><_>zbývá do 50% slevy na pronájem prostor v Café New One.</_></span>
                                                                    </p>
                                                                )} */}
                                                            </>
                                                        );
                                                    })()}
                                                    <div className="text-[14px] text-brown-text mt-[2px]"><_>{opt.desc}</_></div>
                                                </div>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>
                    )}
                    <div className="w-full nMob:hidden">
                        <div className="mb-[24px] font-bold text-black text-[16px]"><_>Vyberte si rozvržení</_></div>
                        <div className="flex flex-col gap-[12px]">
                            {eventLayouts.map((o) => {
                                const isActive = form.data.layout === o.key;
                                return (
                                    <div key={o.key} className="border border-gray rounded overflow-hidden">
                                        <label
                                            className={`flex flex-col items-start justify-between px-[16px] py-[12px] cursor-pointer transition-all
                                    ${isActive ? "font-semibold text-black border-black border" : "transform duration-300"}`}
                                            onClick={() => form.setData("layout", o.key)}
                                        >
                                            <div className="flex items-center">
                                                <input
                                                    type="radio"
                                                    className="accent-[#666666] py-12px mr-[16px] w-[18px] h-[18px]"
                                                    name="layout"
                                                    value={o.key}
                                                    /* checked={form.data.layout === o.key} */
                                                    onChange={() => form.setData("layout", o.key)}
                                                />
                                                <span className="text-[16px] font-normal py-12px"><_>{o.label}</_></span>
                                            </div>

                                            {isActive && (
                                                <div className="">
                                                    <Img
                                                        src={eventImages[o.key]}
                                                        className="mob:w-auto mob:h-auto  "
                                                    />

                                                </div>
                                            )}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Balíčky zůstávají stejné, jen pod akordeonem pro mobil */}
                        <div className="mt-[40px] w-full flex flex-col gap-[12px]">
                            <div className="font-bold text-black text-[16px] mb-[12px]"><_>Vyberte si balíček</_></div>
                            {rentalPackages.map((opt) => (

                                <div className="border border-gray  overflow-hidden" key={opt.key}>
                                    <label
                                        key={opt.key}
                                        className={`flex font-normal items-start  px-[16px] py-[16px] cursor-pointer transition-all
                                 ${form.data.rental_packages == opt.key ? "bg-white" : "border-[#ddd] bg-white"}`}
                                        style={{ minHeight: 56 }}>
                                        <div className="flex items-center justify-center w-[24px] h-[24px] bg-white rounded-full">
                                            <input
                                                type="radio"
                                                className="accent-[#897A69] w-[12px] h-[12px]"
                                                name="rental_packages"
                                                value={opt.key}
                                                /* checked={form.data.rental_packages === opt.key} */
                                                onChange={() => form.setData("rental_packages", opt.key)}
                                                style={{ background: "white" }}
                                            />
                                        </div>
                                        <div className="flex-1 flex flex-col min-w-0 ml-[12px]">
                                            <div className="flex items-center justify-between w-full">
                                                <div className="font-bold text-[16px] leading-[24px] text-brown-text"><_>{opt.title}</_></div>
                                                {opt.price && (() => {
                                                    const match = opt.price.match(/(\d[\d\s]*)/);
                                                    const rentalCost = match ? parseInt(match[1].replace(/\s/g, ''), 10) : 0;
                                                    const cateringCost =
                                                        form.data.package_type === "custom"
                                                            ? (form.data.menu_total_price || 0)
                                                            : (packages[form.data.package_index]?.pricePerPerson ?? 0) * form.data.person_count;
                                                    const remaining = Math.max(cateringDiscountThreshold - cateringCost, 0);
                                                    const isDiscounted = remaining <= 0;
                                                    if (isDiscounted) {
                                                        return (
                                                            <span className="ml-auto whitespace-nowrap font-normal text-[14px] flex items-center">
                                                                <span className="text-brown-text font-normal line-through leading-[24px] mr-12px">
                                                                    od {rentalCost.toLocaleString("cs-CZ")} Kč
                                                                </span>
                                                                <span className="text-brown-text font-normal leading-[24px] text-[14px]">
                                                                    od {(rentalCost / 2).toLocaleString("cs-CZ")} Kč
                                                                </span>
                                                            </span>
                                                        );
                                                    } else {
                                                        return (
                                                            <span className="ml-auto whitespace-nowrap font-normal text-[16px] text-brown-text">
                                                                od {rentalCost.toLocaleString("cs-CZ")} Kč
                                                            </span>
                                                        );
                                                    }
                                                })()}
                                            </div>
                                            <div className="text-[16px] leading-[24px] font-normal text-brown-text mt-[2px]">
                                                <_>{opt.desc}</_>
                                            </div>

                                        </div>
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>



                    {/* Vaše požadavky */}
                    <div className=" w-full pb-12px mob:pt-[12px]  border-[#E0DCD8] ">
                        <div className=" font-normal text-brown-text text-[14px] leading-[24px]"><_>Vaše požadavky</_></div>
                        <CTextField
                            name="request"
                            noCheck
                            className="w-full min-h-[48px] border border-[#E0DCD8]  py-[8px] bg-white text-[15px]"
                            placeholder="Místo pro upřesnění či vaše specifické požadavky"
                        />
                    </div>

                    {/* Formulář */}
                    <div className="w-full flex flex-col gap-16px ">
                        <div className="flex gap-[16px] ">
                            <div className="flex-1">
                                <div className="font-normal text-brown-text text-[14px]"><_>Jméno*</_></div>
                                <CTextField noCheck placeholder='Jméno' name="name" required className="w-full  border border-[#E0DCD8]  bg-white text-[15px]" />
                            </div>
                        </div>
                        <div className="flex-1">
                            <div className="font-normal text-brown-text text-[14px]"><_>Příjmení*</_></div>
                            <CTextField noCheck placeholder='Příjmení' name="surname" required className="w-full border border-[#E0DCD8] bg-white text-[15px]" />
                        </div>
                        <div className="">
                            <div className="font-normal text-brown-text text-[14px]"><_>Název firmy</_></div>
                            <CTextField noCheck placeholder='Název firmy' name="company" className="w-full border border-[#E0DCD8] bg-white text-[15px]" />
                        </div>
                        <div className="flex gap-[16px]">
                            <div className="flex-1">
                                <div className=" font-normal text-brown-text text-[14px]"><_>Telefon*</_></div>
                                <CTextField noCheck placeholder='Telefon' name="phone" required className="w-full border border-[#E0DCD8] bg-white text-[15px]" />
                            </div>
                            <div className="flex-1">
                                <div className=" font-normal text-brown-text text-[14px]"><_>E-mail*</_></div>
                                <CTextField noCheck placeholder='E-mail' name="email" required type="email" className="w-full border border-[#E0DCD8] bg-white text-[15px]" />
                            </div>
                        </div>
                    </div>

                    {children}

                </div>
                {/* Right column: sticky event image, always visible */}
                <div className="ml-[80px]  mob:hidden mt-[32px]">
                    <div className="sticky top-[64px]">
                        <Img
                            className="object-contain  w-auto h-full  "
                            src={eventImages[form.data.layout] || eventImages["event1"]}
                            alt={form.data.layout}
                        />
                    </div>
                </div>
            </div>
        </div >
    );
}





export const packages = [
    {
        name: "Exclusive",
        pricePerPerson: 999,
        minPersons: 10,
        note: "",
        sections: [
            {
                title: "Finger food & předkrmy",
                description: "lehké, elegantní začátky – ideální ke sklenici vína nebo prosecca nebo prosecca",
                items: [
                    { name: "1x Kanapka s hovězím tatarákem, hruškovou hořčici" },
                    { name: "1x Vitello tonato" },
                    { name: "1x Selecké sýry a šunek" },
                    { name: "1x Špíz s krevetou, sezamem a olivou" },
                    { name: "1x Mini burger s kozím sýrem, rukolou a sušenými rajčaty" },
                ],
            },
            {
                title: "Teplý raut",
                description: "teplé hlavní chody – kombinace masa, zeleniny a lehké omáčky",
                items: [
                    { name: "1x Pečený losos s provensálskými kořeními a citrony (50g)" },
                    { name: "1x Kuřecí stripsy (50g)" },
                    { name: "1x Telecí saltimbocca s parmskou šunkou a šalvějí (50g)" },
                    { name: "1x Vepřová panenka v pepřové omáčce (50g)" },
                    { name: "1x Pečený hermelín s uzenou paprikou a bylinkami (50g)" },
                ],
            },
            {
                title: "Salát & příloha",
                description: "lehké doplňky k hlavním chodům",
                items: [
                    { name: "1x Caesar salát s pancettou a krutony (40g)" },
                    { name: "1x Pečené grenaille s rozmarýnem (75g)" },
                    { name: "1x Grilované papriky a červená cibule (75g)" },
                    { name: "1x Salát coleslaw (40g)" },
                ],
            },
            {
                title: "Minidezerty",
                description: "sladká tečka na závěr",
                items: [
                    { name: "1x Variace minidezertů Café New One 3ks/os." },
                    { name: "1x Malinový cheesecake, salty peanut, mango eclair, makronka, dubaj eclair, pistácie, dort pavlova, míša dezert, vanilková panna cotta" },
                ],
            },
        ],
    },
    {
        name: "Standard",
        pricePerPerson: 699,
        minPersons: 10,
        note: "23 100 Kč zbývá do 50% slevy na pronájem prostor v Café New One.",
        sections: [
            {
                title: "Finger food & předkrmy",
                description: "lehké, elegantní začátky – ideální ke sklenici vína nebo prosecca",
                items: [
                    { name: "1x Kanapka s uzeným lososem, citronový creme fraiche, kopr" },
                    { name: "1x Mini burger s trhaným hovězím masem" },
                    { name: "1x Špíz mini caprese s bazalkou" },
                    { name: "1x Mini croissant s emmentálem a šunkou od kosti" },
                ],
            },
            {
                title: "Teplý raut",
                description: "teplé hlavní chody – kombinace masa, zeleniny a lehké omáčky",
                items: [
                    { name: "1x Pečený losos s provensálskými kořeními a citrony (50g)" },
                    { name: "1x Kuřecí stripsy (50g)" },
                    { name: "1x Vepřová marinovaná žebra BBQ (50g)" },
                    { name: "1x Rajčatové lasagne s mozzarellou a bazalkou (50g)" },
                ],
            },
            {
                title: "Salát & příloha",
                description: "lehké doplňky k hlavním chodům",
                items: [
                    { name: "1x Caesar salát s pancettou a krutony (40g)" },
                    { name: "1x Pečené grenaille s rozmarýnem (75g)" },
                    { name: "1x Mísová zelenina (75g)" },
                ],
            },
            {
                title: "Minidezert",
                description: "sladká tečka na závěr",
                items: [
                    { name: "1x Vanilková Panna Cotta s lesním ovocem" },
                    { name: "1x Makronka" },
                ],
            },
        ],
    },
    {
        name: "Basic",
        pricePerPerson: 499,
        minPersons: 10,
        note: "",
        sections: [
            {
                title: "Finger food & předkrmy",
                description: "lehké, elegantní začátky – ideální ke sklenici vína nebo prosecca",
                items: [
                    { name: "1x Kanapka s cibulovou ricottou a parmskou šunkou" },
                    { name: "1x Špíz mini caprese s bazalkou" },
                    { name: "1x Roastbeef s dijonskou majonézou" },
                ],
            },
            {
                title: "Teplý raut",
                description: "teplé hlavní chody – kombinace masa, zeleniny a lehké omáčky",
                items: [
                    { name: "1x Kuřecí ve smetanové omáčce (50g)" },
                    { name: "1x Vepřové řízečky (50g)" },
                    { name: "1x Lasagne bolognese (50g)" },
                ],
            },
            {
                title: "Salát & příloha",
                description: "lehké doplňky k hlavním chodům",
                items: [
                    { name: "1x Řecký salát (40g)" },
                    { name: "1x Dlouhozrnná rýže (50g)" },
                    { name: "1x Focaccia (50g)" },
                ],
            },
            {
                title: "Minidezert",
                description: "sladká tečka na závěr",
                items: [
                    { name: "1x Míša dezert" },
                ],
            },
        ],
    },
];

// CUSTOM MENU (Sestavte si menu)
export const CustomMenu: CustomMenuType = {
    pricePerPerson: 999,
    minPersons: 10,
    note: "23 100 Kč zbývá do 50% slevy na pronájem prostor v Café New One.",
    sections: [
        {
            title: "Finger food & předkrmy",
            description: "lehké, elegantní začátky – ideální ke sklence vína nebo prosecca",
            items: [
                { name: "Kanapka s hovězím tatarákem, hrušková hořčice", price: 40, defaultCount: 1 },
                { name: "Vitello tonato", price: 60, defaultCount: 1 },
                { name: "Selecké sýry a šunek", price: 60, defaultCount: 1 },
                { name: "Špíz s krevetou, sezamem a olivou", price: 80, defaultCount: 1 },
                { name: "Mini burger s kozím sýrem, rukolou a sušenými rajčaty", price: 60, defaultCount: 1 }
            ]
        },
        {
            title: "Teplý raut",
            description: "teplé hlavní chody – kombinace masa, zeleniny a lehké omáčky",
            items: [
                { name: "Pečený losos s provensálskými kořeními a citrony (50g)", price: 90, defaultCount: 1 },
                { name: "Kuřecí stripsy (50g)", price: 75, defaultCount: 1 },
                { name: "Telecí saltimbocca s parmskou šunkou a šalvějí (50g)", price: 80, defaultCount: 1 },
                { name: "Vepřová panenka v pepřové omáčce (50g)", price: 80, defaultCount: 1 },
                { name: "Pečený hermelín s uzenou paprikou a bylinkami (50g)", price: 45, defaultCount: 1 }
            ]
        },
        {
            title: "Salát & příloha",
            description: "lehké doplňky k hlavním chodům",
            items: [
                { name: "Caesar salát s pancettou a krutony (40g)", price: 50, defaultCount: 1 },
                { name: "Pečené grenaille s rozmarýnem (75g)", price: 40, defaultCount: 1 },
                { name: "Grilované papriky a červená cibule (75g)", price: 45, defaultCount: 1 },
                { name: "Salát coleslaw (40g)", price: 35, defaultCount: 1 }
            ]
        },
        {
            title: "Minidezerty",
            description: "sladká tečka na závěr",
            items: [
                { name: "Variace minidezertů Café New One 3ks/os.", price: 159, defaultCount: 1 },
                { name: "Malinový cheesecake, salty peanut, mango eclair, makronka, dubaj eclair, pistácie, dort pavlova, míša dezert, vanilková panna cotta", defaultCount: 1 }
            ]
        }
    ]
}


interface DemandCardProps {
    min?: number;
    max?: number;
    defaultValue?: number;
}

function DemandCard({
    min = 1,
    max = 100,
    defaultValue = 10,
}) {
    const [count, setCount] = useState(defaultValue);
    const increment = () => setCount((c) => Math.min(max, c + 1));
    const decrement = () => setCount((c) => Math.max(min, c - 1));
    const [prefix, setPrefix] = useState("");

    const initialMenu: CustomMenuType = {
        sections: CustomMenu.sections.map(section => ({
            ...section,
            items: section.items.map(item => ({
                ...item,
                count: item.defaultCount ?? 1,
            })),
        })),
        pricePerPerson: CustomMenu.pricePerPerson,
        minPersons: CustomMenu.minPersons,
        note: CustomMenu.note,
        totalPrice: CustomMenu.pricePerPerson * defaultValue,
    };

    const form = useCForm<FormData>({
        street: "",
        person_count: 10,
        city: "",
        zip: "",
        company: "",
        name: "",
        surname: "",
        phone: "",
        event_type: "cafe",
        package_type: "exclusive",
        layout: "wedding",
        email: "",
        request: "",
        /* menu_custom_total_price: 0, */
        menu_total_price: 0,
        agree: false,
        rental_packages: "zakladni",
        package_index: 0,
        menu_custom: null,

    });

    useEffect(() => {
        if (!form.data.menu_custom) {
            form.setData("menu_custom", initialMenu);
        }
    }, []);



    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    const submit = (e) => {
        e.preventDefault();

        const clientErrors: Record<string, string> = {};
        if (!form.data.name?.trim()) clientErrors.name = "Vyplňte prosím jméno.";
        if (!form.data.surname?.trim()) clientErrors.surname = "Vyplňte prosím příjmení.";
        if (!form.data.phone?.trim()) {
            clientErrors.phone = "Vyplňte prosím telefon.";
        } else if (!/^\+?\d{9,15}$/.test(form.data.phone.replace(/[\s\-()]/g, ''))) {
            clientErrors.phone = "Zadejte prosím platné telefonní číslo.";
        }
        if (!form.data.email?.trim()) {
            clientErrors.email = "Vyplňte prosím e-mail.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.data.email)) {
            clientErrors.email = "Zadejte prosím platný e-mail.";
        }

        if (Object.keys(clientErrors).length > 0) {
            (form as any).setErrors(clientErrors);
            requestAnimationFrame(() => {
                const firstErrorField = document.querySelector(
                    `#demand-card [name="${Object.keys(clientErrors)[0]}"]`
                ) as HTMLElement | null;
                firstErrorField?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                firstErrorField?.focus({ preventScroll: true });
            });
            return;
        }

        const scrollPosition = window.scrollY;
        setIsSubmitting(true);
        setSubmitSuccess(false);

        const restoreScroll = () => window.scrollTo(0, scrollPosition);

        form.post(route('form.store'), {
            preserveScroll: true,
            preserveState: true,
            onSuccess: () => {
                form.reset();
                setIsSubmitting(false);
                setSubmitSuccess(true);
                requestAnimationFrame(restoreScroll);
                setTimeout(restoreScroll, 0);
                setTimeout(restoreScroll, 80);
                setTimeout(restoreScroll, 250);
                setTimeout(() => setSubmitSuccess(false), 8000);
            },
            onError: () => {
                setIsSubmitting(false);
                requestAnimationFrame(restoreScroll);
                setTimeout(restoreScroll, 0);
                setTimeout(restoreScroll, 80);
                setTimeout(restoreScroll, 250);
            },
        });
    };

    const customMenuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!prefix) {
            setPrefix("+420");
        }
    }, [prefix]);

    function handleSelectPackage(idx: number) {
        const types = ["exclusive", "standard", "basic"];
        const selectedType = types[idx];
        const selectedPackage = packages[idx];
        const cateringCost = selectedPackage.pricePerPerson * form.data.person_count;
        form.setData({
            ...form.data,
            package_type: selectedType,
            package_index: idx,
            menu_custom: null,
            menu_total_price: cateringCost,
        });
        console.log("Selected package index:", idx);
    }

    function handleSelectCustomMenu() {
        // Build initial custom menu with count fields

        const initialCustomMenu: CustomMenuType = {
            ...CustomMenu,
            sections: CustomMenu.sections.map(section => ({
                ...section,
                items: section.items.map(item => ({
                    ...item,
                    count: item.defaultCount ?? 1,
                })),
            })),
        };
        form.setData({
            ...form.data,
            package_type: "custom",
            package_index: null,
            menu_custom: initialCustomMenu,
        });
    }

    useEffect(() => {
        if (form.data.package_type === "custom" && customMenuRef.current) {
            customMenuRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [form.data.package_type]);

    const selectedMinPersons =
        form.data.package_type === 'custom'
            ? form.data.menu_custom?.minPersons ?? 10
            : packages[form.data.package_index ?? 0]?.minPersons ?? 10;
    const isBelowMin = form.data.person_count < selectedMinPersons;

    // --- Section height equalization logic ---
    const numPackages = packages.length;
    const numSections = packages[0].sections.length;
    const sectionRefs = useRef<HTMLDivElement[][]>([]);
    if (sectionRefs.current.length === 0) {
        sectionRefs.current = Array(numPackages).fill(null).map(() => Array(numSections).fill(null));
    }
    const equalizeSectionHeights = () => {
        // reset any previously set inline heights
        sectionRefs.current.forEach(packageRefs =>
            packageRefs.forEach(el => {
                if (el) (el as HTMLElement).style.height = 'auto';
            })
        );
        const maxHeights = Array(numSections).fill(0);
        sectionRefs.current.forEach(packageRefs =>
            packageRefs.forEach((el, idx) => {
                if (el) maxHeights[idx] = Math.max(maxHeights[idx], el.getBoundingClientRect().height);
            })
        );
        sectionRefs.current.forEach(packageRefs =>
            packageRefs.forEach((el, idx) => {
                if (el) (el as HTMLElement).style.height = `${maxHeights[idx]}px`;
            })
        );
    };
    useEffect(() => {
        equalizeSectionHeights();
        window.addEventListener('resize', equalizeSectionHeights);
        return () => window.removeEventListener('resize', equalizeSectionHeights);
    }, [form.data.package_index]);

    return (
        <CForm id="demand-card" noValidate onSubmit={submit} className="" form={form}>
            <div className="max-w-lg ">
                <h1 className="text-h32 mob:px-[16px] mb-24px mob:mt-[16px] leading-[40px] mob:text-16px mt-[32px] font-bold "><_>Nezávazná poptávka</_></h1>
                <p className="mb-6 mob:px-[16px] text-brown-text font-normal text-16"><_>
                    Objednávka musí být potvrzena 2 dny před eventem v případě potřeby volejte na</_>
                    <a href="tel:+420734391471" className="font-bold "> +420 734 391 471</a> <_>nebo pište na</_>
                    <a href="mailto:info@cafenewone.cz" className="font-bold "> info@cafenewone.cz</a>
                </p>
                <label className="block mob:px-[16px] mob:w-full mt-24px text-14 text-brown-text font-normal" htmlFor="pocet-osob">
                    <_>Počet osob*</_>
                </label>
                <div className="flex mob:ml-[16px] p-16px my-auto items-center border border-[#897A6942] w-full max-w-xs overflow-hidden">
                    <button
                        className="w-24px mob:px-[16px] h-24px text-24 text-black flex items-center justify-center"
                        onClick={() => form.setData("person_count", Math.max(min, form.data.person_count - 1))}
                        type="button"
                    >
                        −
                    </button>
                    <input
                        id="pocet-osob"
                        name="person_count"
                        className="flex-1 mob:px-[16px] text-center text-20 font-semibold outline-none bg-white"
                        type="number"
                        min={min}
                        max={max}
                        value={form.data.person_count}
                        onChange={(e) => form.setData("person_count", Number(e.target.value))}
                    />
                    <button
                        className="w-24px h-24px text-24 text-black flex items-center justify-center"
                        onClick={() => form.setData("person_count", Math.min(max, form.data.person_count + 1))}
                        type="button"
                    >
                        +
                    </button>
                </div>
                {isBelowMin && (
                    <p className="text-red-600 text-[14px] mt-2">
                        Minimální počet osob je {selectedMinPersons}. Prosím, zvyšte počet osob.
                    </p>
                )}
            </div>

            <div className="w-1/2 mob:w-full">
                <div className="flex mob:px-16px  justify-start mt-[8px] mb-[6px]">
                    <button
                        type="button"
                        className={`pt-[40px] pb-[16px] border-b-[2px] font-myriad text-[24px] leading-[40px] font-bold transition-all flex-1 flex items-center justify-start text-left
                        ${form.data.package_type === 'custom'
                                ? 'border-gray text-brown-text'
                                : 'border-brown-text text-black'
                            }`}
                        onClick={() => handleSelectPackage(form.data.package_index ?? 0)}
                    >
                        <_ className="">Vybrat balíček</_>
                    </button>
                    <button
                        type="button"
                        className={`pt-[40px] pb-[16px] border-b-[2px] font-myriad text-[24px] leading-[40px] font-bold transition-all flex-1 flex items-center justify-start text-left
                        ${form.data.package_type !== 'custom'
                                ? 'border-gray text-brown-text'
                                : 'border-brown-text text-black'
                            }`}
                        onClick={handleSelectCustomMenu}
                    >
                        <_>Sestavit si menu</_>
                    </button>
                </div>
            </div>


            <div className="bg-white rounded-0 mt-32px mb-24px">
                {form.data.package_type !== "custom" ? (
                    <div className="w-full mob:overflow-x-auto">
                        <div className="grid grid-cols-1 mob:flex sm:grid-cols-2 md:grid-cols-3 gap-y-[16px]">
                            {packages.map((pkg, pkgIdx) => (
                                <div key={pkg.name} className={`flex mb-16px relative flex-col w-full border ${form.data.package_index === pkgIdx ? "bg-white border-brown-light border-[1px]" : "bg-white border-[#e5e5e5]"} transition-all`} onClick={() => handleSelectPackage(pkgIdx)} >

                                    <div className="flex-1 mob:p-[12px] mob:w-[323px] flex flex-col md:px-[48px] pt-[32px] pb-[32px] text-start cursor-pointer border-b border-[#E0DCD8]">
                                        <h2 className="text-[48px]  leading-[56px] font-aldo font-semibold text-[#897A69] ">
                                            {pkg.name === "Exclusive" ? "Exclusive" : pkg.name}
                                        </h2>
                                        <div className="border-gray border-t my-16px "></div>
                                        <div className=" ">
                                            {pkg.sections.map((section, sectionIdx) => (
                                                <div
                                                    key={section.title}
                                                    ref={el => { sectionRefs.current[pkgIdx][sectionIdx] = el; }}
                                                    className={`pb-[16px] mb-[16px] ${sectionIdx < pkg.sections.length - 1 ? "border-b border-[#E0DCD8]" : ""}`}>
                                                    <h3 className="text-[18px] leading-[24px] font-bold text-brown-text mb-[8px] text-start">
                                                        <_>{section.title}</_>
                                                    </h3>
                                                    {section.description && (
                                                        <p className="text-[14px] leading-[24px] text-brown-text mb-[8px] text-start">
                                                            <_>{section.description}</_>
                                                        </p>
                                                    )}
                                                    <div className="flex flex-col text-[16px] font-normal text-brown-text text-start leading-[24px]">
                                                        {section.items.map((item) => (
                                                            <div key={item.name}>
                                                                {(() => {
                                                                    const match = item.name.match(/(.+?)\s*\((\d+g)\)/);
                                                                    if (match) {
                                                                        return (
                                                                            <>
                                                                                <_>{match[1].trim()}</_>
                                                                                {' '}
                                                                                <span className="text-[12px] font-regular">{match[2]}</span>
                                                                            </>
                                                                        );
                                                                    }
                                                                    return <_>{item.name}</_>;
                                                                })()}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Packgages price panel */}
                                    <div className={`w-full sticky  bottom-0 cursor-pointer mob:p-24px min-h-[230px] py-48px px-48px text-center flex flex-col justify-start ${form.data.package_index === pkgIdx ? "bg-[#8B7B68] text-white" : "bg-white text-brown-text border-t border-[#e5e5e5]"} border-b border-brown-light`} >
                                        <p className="text-[32px] text-start leading-[40px] font-bold">
                                            {pkg.pricePerPerson} Kč / <_>os.</_>
                                        </p>
                                        <p className="text-[16px] text-start mt-[8px]">
                                            {form.data.person_count} <_>osob za</_>{" "}
                                            <span className="font-bold pl-4px ">
                                                {(pkg.pricePerPerson * form.data.person_count).toLocaleString("cs-CZ")} Kč
                                            </span>
                                        </p>
                                        {form.data.package_index === pkgIdx && (
                                            <p className="text-[14px] leading-[24px] mt-[8px]  text-white font-normal  text-start">
                                                {(() => {
                                                    const cost = pkg.pricePerPerson * form.data.person_count;
                                                    const remaining = Math.max(cateringDiscountThreshold - cost, 0);
                                                    if (remaining > 0) {
                                                        return (
                                                            <>
                                                                <span className="font-bold pr-4px text-white text-start">{remaining.toLocaleString("cs-CZ")} Kč</span>{' '}
                                                                <_>{` zbývá do 50% slevy na pronájem prostor v Café New One.`}</_>
                                                            </>
                                                        );
                                                    }
                                                    return <_>Gratulujeme! Dosáhli jste 50% slevy na pronájem prostor v Café New One.</_>;
                                                })()}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div ref={customMenuRef}>
                        <CustomMenuSection
                            menu={form.data.menu_custom}
                            setMenu={menu => {
                                form.setData("menu_custom", menu);
                                form.setData("menu_total_price", menu?.totalPrice ?? 0);
                            }}

                            menu_total_price={form.data.menu_total_price}
                            person_count={form.data.person_count}
                            onSelectCustomMenu={handleSelectCustomMenu}
                            form={form}
                        />

                    </div>
                )}

            </div>
            <div>
                <Events onSelectCustomMenu={handleSelectCustomMenu}>
                    {submitSuccess && (
                        <div role="status" className="w-full mt-[24px] mb-[8px]">
                            <div className="bg-[#E8F5E9] border border-green text-[#2E5A1A] px-[20px] py-[16px] flex items-start gap-[12px] rounded-[2px]">
                                <span className="text-[20px] leading-[24px]">✓</span>
                                <div>
                                    <div className="font-bold text-[16px] leading-[24px]"><_>Vaše poptávka byla úspěšně odeslána.</_></div>
                                    <div className="text-[14px] leading-[20px] mt-[4px]"><_>Děkujeme - co nejdříve se vám ozveme.</_></div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="flex w-full mob:flex-col pb-80px flex-row items-center justify-between mt-[24px]">
                        <div className="flex items-center text-brown-text text-[14px] leading-[20px]">
                            <span>
                                <_>Odesláním poptávky souhlasíte se</_>{" "}
                                <a
                                    href="/assets/cafenewone_GDPR.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="underline hover:opacity-75"
                                >
                                    <_>zpracováním osobních údajů (GDPR)</_>
                                </a>
                                .
                            </span>
                        </div>
                        <div className="mob:mt-[16px] mob:self-end">
                            <button
                                type="submit"
                                disabled={isBelowMin || isSubmitting}
                                title={isBelowMin ? `Minimální počet osob je ${selectedMinPersons}` : undefined}
                                className={`w-[100px] mob:w-1/3 bg-brown-light font-bold font-myriad hover:underline cursor-pointer py-11px text-center rounded-[2px] text-white ${isBelowMin || isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                    }`}
                            >
                                {isSubmitting ? 'Odesílání...' : 'Odeslat'}
                            </button>
                        </div>
                    </div>
                </Events>
            </div>

        </CForm>
    );
};


function useMenuTabs() {
    const [selectedType, setSelectedType] = useState<"package" | "custom">("package");
    const [selectedPackage, setSelectedPackage] = useState(0);
    return { selectedType, setSelectedType, selectedPackage, setSelectedPackage };
}


const DemandCardWithTabs: React.FC<DemandCardProps> = (props) => {
    const { selectedType, setSelectedType, selectedPackage, setSelectedPackage } = useMenuTabs();
    // @ts-ignore
    return <DemandCardInner {...props} selectedType={selectedType} setSelectedType={setSelectedType} selectedPackage={selectedPackage} setSelectedPackage={setSelectedPackage} />;
};


function DemandCardInner({ }: DemandCardProps & { selectedType: "package" | "custom"; setSelectedType: (type: "package" | "custom") => void; selectedPackage: number; setSelectedPackage: (idx: number) => void; }) {
    return <></>;
}
function CustomMenuSection({ menu, setMenu, menu_total_price, person_count, onSelectCustomMenu, form }: CustomMenuSectionProps) {
    useEffect(() => {
        if (!menu) return;
        const pPrice = menu.sections.reduce(
            (sum, sec) =>
                sum + sec.items.reduce((s, it) => s + (it.price ?? 0) * (it.count ?? 0), 0),
            0
        );
        const tPrice = pPrice * person_count;
        setMenu({
            ...menu,
            pricePerPerson: pPrice,
            totalPrice: tPrice,
        });
        form.setData("menu_total_price", tPrice);
    }, [form.data.menu_custom, person_count]);

    useEffect(() => {
    }, [form.data.menu_custom]);

    function renderNote(note: string, isDiscounted: boolean = false, remaining: number = 0) {
        const match = note.match(/^([\d\s]+)\s*Kč/);
        if (match) {
            const threshold = parseInt(match[1].replace(/\s/g, ''), 10);
            if (isDiscounted) {
                return (
                    <div className="flex flex-col items-start">
                        <span className="font-normal text-white block">
                            Gratulujeme! Dosáhli jste 50% slevy na pronájem prostor v Café New One.
                        </span>
                    </div>
                );
            }

            return (
                <div className="flex flex-row items-end">
                    <span className="font-bold text-white text-[14px] mr-2px">{remaining.toLocaleString('cs-CZ')} Kč</span>
                    <span className="text-white font-normal text-[14px]"> zbývá do 50% slevy na pronájem prostor v Café New One.</span>
                </div>
            );
        }
        return note;
    }

    const personPrice = (() => {
        if (!menu) return 0;
        let sum = 0;
        menu.sections.forEach((section, sectionIdx) => {
            section.items.forEach((item, itemIdx) => {
                const count = form.data.menu_custom?.sections?.[sectionIdx]?.items?.[itemIdx]?.count ?? 0;
                if (typeof item.price === "number" && count > 0) {
                    sum += item.price * count;
                }
            });
        });
        return sum;
    })();
    const totalPrice = personPrice * person_count;

    return (
        <div className="border border-gray">
            <div className="px-48px relative pt-48px  mob:px-24px mob:pt-24px">
                <h2 className="text-48 leading-[56px] font-aldo text-brown-light font-semibold mb-2">Na míru</h2>
                <div className="text-14 pb-8px font-normal text-brown-text border-b border-gray">
                    Navolte si počet porcí na jednu osobu
                </div>
                <div className="bg-white">
                    {menu?.sections.map((section, sectionIdx) => (
                        <section
                            key={section.title}
                            className={
                                (sectionIdx > 0 ? "border-t bg-white border-gray mt-6px pt-[12px] " : "") + "mb-0"
                            }
                        >
                            <div className="mt-16px mb-4px">
                                <div className="text-18 leading-[24px] font-bold text-brown-text">{section.title}</div>
                                {section.description && (
                                    <div className="text-14 font-normal text-brown-text mb-4px">{section.description}</div>
                                )}
                            </div>
                            <div className="bg-white flex flex-col gap-4px">
                                {section.items.map((item, itemIdx) => (
                                    <div key={item.name} className="mb-[4px]">
                                        <div className="flex items-baseline py-[4px]">
                                            <div className="flex items-baseline gap-[8px]">

                                                <input
                                                    type="number"
                                                    name={`menu_custom.sections.${sectionIdx}.items.${itemIdx}.count`}
                                                    className="text-center w-35px h-35px text-brown-text px-2 py-1 text-16 font-normal border border-gray outline-none"
                                                    value={form.data.menu_custom?.sections?.[sectionIdx]?.items?.[itemIdx]?.count ?? 0}
                                                    onChange={e => {
                                                        const numericValue = Math.max(0, Number(e.target.value) || 0);
                                                        const menuCopy = JSON.parse(JSON.stringify(form.data.menu_custom));
                                                        menuCopy.sections[sectionIdx].items[itemIdx].count = numericValue;
                                                        form.setData("menu_custom", menuCopy);
                                                    }}
                                                    min={0}
                                                    step={1}
                                                    autoComplete="off"
                                                />

                                                <span className="text-brown-text font-normal text-16 leading-[24px] text-left break-words">
                                                    {(() => {
                                                        const count = form.data.menu_custom?.sections?.[sectionIdx]?.items?.[itemIdx]?.count ?? 0;
                                                        // Extract base name and weight (e.g., "50g") without parentheses
                                                        const match = item.name.match(/(.+?)\s*\((\d+g)\)/);
                                                        const baseName = match ? match[1].trim() : item.name;
                                                        const weight = match ? match[2] : null;
                                                        return (
                                                            <>
                                                                {count}x {baseName}
                                                                {weight && <span className="text-[12px] font-normal"> {weight}</span>}
                                                            </>
                                                        );
                                                    })()}
                                                </span>
                                            </div>
                                            <div className="flex-1 border-b border-gray mx-[12px]" />
                                            {(() => {
                                                const count = form.data.menu_custom?.sections?.[sectionIdx]?.items?.[itemIdx]?.count ?? 0;
                                                if (item.price && count) {
                                                    return (
                                                        <span className="font-normal whitespace-nowrap text-brown-text">
                                                            {(item.price * count).toLocaleString('cs-CZ')} Kč
                                                        </span>
                                                    );
                                                } else if (item.price) {
                                                    return (
                                                        <span className="font-normal whitespace-nowrap">
                                                            {item.price} Kč
                                                        </span>
                                                    );
                                                }
                                                return null;
                                            })()}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    ))}
                </div>
            </div>

            {/* Custom price panel */}
            <div className="flex sticky bottom-0 flex-row w-full justify-between items-stretch mob:items-start bg-brown-light mt-[48px] text-white px-0 py-0 rounded">
                <div className="flex flex-col justify-between mob:pl-24px mob:py-24px pl-[48px] py-[42px]">
                    <span
                        className={`font-bold w-full pr-48px text-[32px] leading-[40px] mb-[6px] whitespace-nowrap ${personPrice < 999 ? 'line-through' : ''}`}
                    >
                        {personPrice.toLocaleString("cs-CZ")} Kč / os.
                    </span>
                    {personPrice < 999 && (
                        <span className="block text-[15px] text-red-600 font-semibold mb-[8px]">
                            Minimální cena objednávky je 999 Kč na osobu. Přidejte další položky!
                        </span>
                    )}
                    <span className="font-normal text-[16px] leading-[24px] mt-[6px]">
                        {person_count} osob za{" "}
                        <span
                            className={`font-bold text-[16px] ml-1 ${personPrice < 999 ? ' line-through' : ''}`}
                        >
                            {(person_count * personPrice).toLocaleString("cs-CZ")} Kč
                        </span>
                    </span>

                    {menu?.note && (() => {
                        const match = menu.note.match(/^([\d\s]+)\s*Kč/);
                        if (match) {
                            const threshold = parseInt(match[1].replace(/\s/g, ''), 10);
                            const rentalCost = person_count * personPrice;
                            const remaining = Math.max(threshold - rentalCost, 0);
                            const isDiscounted = remaining <= 0;
                            if (isDiscounted) {
                                // Show congrat note below price on mobile only
                                return (
                                    <div className="mob:block mt-2px font-normal hidden pr-24px text-[14px] leading-[24px] text-start">
                                        Gratulujeme!
                                        Dosáhli jste 50% slevy
                                        na pronájem prostor v Café New One.
                                    </div>
                                );
                            }
                        }
                        return null;
                    })()}
                </div>
                <div className="flex items-center mob:hidden justify-end px-[48px] py-[42px] w-full ">
                    {menu?.note && (() => {
                        const match = menu.note.match(/^([\d\s]+)\s*Kč/);
                        if (match) {
                            const threshold = parseInt(match[1].replace(/\s/g, ''), 10);
                            const rentalCost = person_count * personPrice;
                            const remaining = Math.max(threshold - rentalCost, 0);
                            const isDiscounted = remaining <= 0;
                            return (
                                <span className={`text-[16px] font-bold ${isDiscounted ? "mob:hidden" : ""}`}>
                                    {isDiscounted ? (
                                        <span>
                                            Gratulujeme! Dosáhli jste 50% slevy na pronájem prostor v Café New One.
                                        </span>
                                    ) : (
                                        renderNote(menu.note, isDiscounted, remaining)
                                    )}
                                </span>
                            );
                        }
                        return (
                            <span className="text-[16px] font-bold">
                                {renderNote(menu.note)}
                            </span>
                        );
                    })()}
                </div>
            </div>
        </div>
    );
}



export default DemandCard;